import {IComponentController, IComponentOptions} from "angular";
import {SortingOrder} from "../orederingComponent/sorting-order.component";
import {Pageable} from "../../../utils/models/Page";
import './sortable-pagination.component.scss';
import {SortableFilter} from "../../../opportunities_filter/model/OpportunityFilterUi";

export class SortablePaginationComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./sortable-pagination.component.html'),
        controller: [SortablePaginationComponent],
        bindings: {
            'filter': '<',
            'pageable': '=',
            'onFilterChanged': '<'
        }
    };

    private filter: SortableFilter;

    private onFilterChanged: (filterChanged: SortableFilter) => void;

    private pageable: Pageable;

    private sortingOrder: SortingOrder = SortingOrder.DESC;


    sortingOrderChanged = (newOrder) => {
        this.filter.sortingOrder = newOrder;
        this.onFilterChanged(this.filter);
    };


}